module.exports = __webpack_public_path__ + "static/media/icon-logout.60491d7e.svg";